// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(min-width: 768px) and (max-width: 1023px)","desktop":"(min-width: 1024px)","content":"styles_content__i7hVm","full":"styles_full__Zofko"};